import { render, staticRenderFns } from "./FormRisk.vue?vue&type=template&id=8acaa358"
import script from "./FormRisk.vue?vue&type=script&lang=js"
export * from "./FormRisk.vue?vue&type=script&lang=js"
import style0 from "./FormRisk.vue?vue&type=style&index=0&id=8acaa358&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports